import { render, staticRenderFns } from "./DownLoadTable2.vue?vue&type=template&id=25f88070&scoped=true&"
import script from "./DownLoadTable2.vue?vue&type=script&lang=js&"
export * from "./DownLoadTable2.vue?vue&type=script&lang=js&"
import style0 from "./DownLoadTable2.vue?vue&type=style&index=0&id=25f88070&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f88070",
  null
  
)

export default component.exports